// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"0070bcc3","138":"6c19ce86","404":"1a0bf54a","897":"5ff12d6c"}[chunkId] + ".chunk.js";
};